import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "./Pages.css";
import { Button, Tooltip } from "@mui/material";
import { getScheduledPodcasts } from "../Services/SchedulesApi";
import Loader from "../Components/Loader";
import { getUserProfileDetails } from "../Services/ShowsApi";
import edit from "../Assests/edit.svg";
import schedule from "../Assests/Schedule.svg";
import { commonConstants } from "../utils/constant";
import { capitalizeNames } from "../utils/nameUtils";
import PodcastCard from "../Components/PodcastCard";

const Schedules = () => {
  const navigate = useNavigate();
  const [podcasts, setPodcasts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState({
    firstName: "",
    lastName: "",
  });

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000); // Simulate loading for 3 seconds
  }, []);

  // Fetch the podcasts data and update the state
  useEffect(() => {
    const fetchPodcasts = async () => {
      try {
        // Fetch podcast details
        const response = await getScheduledPodcasts(); // API call to fetch podcasts
        setPodcasts(response?.data?.Data); // Update podcasts data

        // Fetch user profile details
        const profileResponse = await getUserProfileDetails("UserID");
        const profileData = profileResponse?.data?.body?.Data?.[0] || {};
        setUserProfile({
          firstName: profileData.FirstName || "",
          lastName: profileData.LastName || "",
        });
        localStorage.setItem(
          "fullName",
          capitalizeNames(profileData.FirstName, profileData.LastName).fullName
        );
      } catch (error) {
        console.error("Error fetching podcasts:", error); // Error handling
      } finally {
        setLoading(false); // End loading after the fetch is complete
      }
    };

    fetchPodcasts();
  }, []);

  // Handle button click to navigate to the create schedule page
  const handleSchedule = () => {
    navigate("/shows/create"); // Navigate to create page
  };

  // Handle click on an existing podcast to edit
  const handleEditPodcast = (podcast) => {
    navigate("/shows/create", { state: { podcast } }); // Pass selected podcast data to the create/edit form
  };

  const handleJoinStudio = (podcast) => {
    if (podcast?.guest) {
      console.log("using Guest stage");
      navigate(
        `/meeting?meetingId=${podcast?.MeetingID}&showName=${podcast?.Title}&guest=${podcast.guest ? "true" : "false"
        }&token=${podcast?.HostMeetingToken}`
      );
    } else {
      console.log("using Host stage");
      navigate(
        `/meeting?meetingId=${podcast?.MeetingID}&showName=${podcast?.Title}&token=${podcast?.HostMeetingToken}`
      );
    }
    // navigate(`/meeting?meetingId=${podcast.MeetingID}&showName=${title}&token=${HostMeetingToken}`);
  };

  return (
    <div className="theme-bg clr-white main-container-schedule">
      <div className="podcast-list-container" >
        {loading ? (
          <div className="show-loader-container">
          <Loader message="Fetching scheduled Podcasts" />
          </div>
        ) : (
          <div className="upcoming-podcast-container">
            {podcasts?.length === 0 ? (
              <div className="podacast-empty-container">
                <h1 className="podacast-empty">No podcasts Found</h1>
              </div>
            ) : (
              podcasts?.map((podcast, index) => (
                <PodcastCard
                  key={index}
                  podcast={podcast}
                  index={index}
                  onPrimaryAction={handleJoinStudio}
                  onSecondaryAction={handleEditPodcast}
                  primaryButtonText="Join Now"
                  secondaryButtonText="Edit"
                  secondaryButtonIcon={edit}
                />
              ))
            )}
          </div>
        )}
      </div>
      <div className="schedule-show-button schedule-podcast">
        <button onClick={handleSchedule}>
          <span className="Schedule-Podcast-button">Schedule Podcast</span>
          <img className="schedule-icon" src={schedule} />
        </button>
      </div>
    </div>
  );
};

export default Schedules;